import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const toastError = (err, location) => {
	const errorMsg = err.response?.data?.message || err.response?.data?.error;
	const httpStatus = err.response?.status;

	if (errorMsg) {
		// Trata ERR_OTHER_OPEN_TICKET:ID com mensagem amigável
		if (typeof errorMsg === "string" && errorMsg.startsWith("ERR_OTHER_OPEN_TICKET")) {
			const parts = errorMsg.split(":");
			const existingId = parts[1] ? `#${parts[1]}` : "";
			toast.error(
				existingId
					? `Contato já possui o ticket ${existingId} em aberto. Finalize-o antes de reabrir este.`
					: i18n.t("backendErrors.ERR_OTHER_OPEN_TICKET"),
				{ toastId: "ERR_OTHER_OPEN_TICKET" }
			);
		} else if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
			});
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
			});
		}
	} else {
		const statusPart = httpStatus ? ` [HTTP ${httpStatus}]` : "";
		const locationPart = location ? ` — em: ${location}` : "";
		toast.error(`Um erro aconteceu${statusPart}${locationPart}`, {
			autoClose: 8000,
		});
	}
};

export default toastError;
